import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { trackPageView } from "../../../services/commons";
import { TRACK, MAX_MOBILE_SIZE } from "../../constants";
import useStyles from "./styles";
import Footer from "../../pres/Footer";
import { getTranslation } from "../../../locales";

const MultilingualWelcome = (props) => {
  const { t } = useTranslation("surveyTaker");
  const { currentTheme, greetingsTranslations, availableLanguages } =
    useSelector((state) => state.survey);
  const styles = useStyles({ ...props, currentTheme });
  const [welcomeObj, setWelcomeObj] = useState({});

  useEffect(() => {
    trackPageView(TRACK.PAGE.SURVEYTAKER_OPENED);
  }, []);

  useEffect(() => {
    greetingText();
  }, [props.value, greetingsTranslations]);

  const greetingText = () => {
    if (greetingsTranslations && greetingsTranslations[props.value]) {
      setWelcomeObj(greetingsTranslations[props.value]);
    } else {
      setWelcomeObj({});
    }
  };

  const isMobile = window.innerWidth < MAX_MOBILE_SIZE;

  return (
    <div className={styles.pageContainer}>
      <div className={styles.wlcmContainer}>
        {welcomeObj && welcomeObj.image_url ? (
          <div className={styles.surveyEndImage}>
            <img src={welcomeObj.image_url} />
          </div>
        ) : (
          ""
        )}
        <h1 className={styles.welcomeHeader}>
          <span>
            {/* {welcomeObj && welcomeObj.title
              ? welcomeObj.title
              : !props.value
              ? props.reportName
              : ""}{" "} */}

            {welcomeObj && welcomeObj.title
              ? welcomeObj.title
              : props.reportName}
          </span>
        </h1>
        {welcomeObj && welcomeObj.description ? (
          <div className={styles.welcomeMessage}>
            <span>{welcomeObj.description}</span>
          </div>
        ) : (
          ""
        )}
        <Grid
          container
          justifyContent="center"
          className={styles.chooseContainer}
        >
          <Grid item>
            <FormLabel
              style={{ color: "#333333", textAlign: "center" }}
              component="legend"
            >
              {t("surveyTaker:chooseLang")}
            </FormLabel>
            <RadioGroup
              row
              aria-label="languageCheck"
              name="languageCheck"
              value={props.value}
              onChange={props.handleChooseLanguage}
            >
              {availableLanguages.map((lang, index) => (
                <FormControlLabel
                  key={index}
                  value={lang.value}
                  control={<Radio />}
                  labelPlacement="end"
                  label={lang.label}
                />
              ))}
            </RadioGroup>
          </Grid>
        </Grid>
        <div className={styles.btnContainer}>
          <Button
            data-testid="welcome-done-btn"
            onClick={props.welcomeDone}
            variant="contained"
            className={styles.getStartedBtn}
            disabled={!props.value}
          >
            {" "}
            {getTranslation(props.currentLang, "surveyTaker:getStarted")}{" "}
          </Button>
        </div>
      </div>
      <div className={styles.footerContainer}>
        <Footer isMobile={isMobile} currentLang={props.currentLang} />
      </div>
    </div>
  );
};

export default MultilingualWelcome;
